(() => {
  if (window.__nestlygiftKlaviyoLoaderInstalled) return;
  window.__nestlygiftKlaviyoLoaderInstalled = true;
  window._learnq = window._learnq || [];
  window._klOnsite = window._klOnsite || [];

  const source = 'https://static.klaviyo.com/onsite/js/YkZZQB/klaviyo.js';
  const interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
  let fallbackTimer;
  let requested = false;

  const removeInteractionListeners = () => {
    interactionEvents.forEach((eventName) => {
      window.removeEventListener(eventName, requestFromInteraction, true);
    });
  };

  const inject = (reason) => {
    if (document.querySelector(`script[src="${source}"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = source;
    script.dataset.delayedLoader = reason;
    document.head.appendChild(script);
  };

  const requestLoad = (reason) => {
    if (requested) return;
    requested = true;
    removeInteractionListeners();
    window.clearTimeout(fallbackTimer);
    const run = () => inject(reason);
    const scheduleIdle = () => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 1500 });
      else window.setTimeout(run, 0);
    };
    // Keep a short quiet window after the first gesture so Klaviyo boot work
    // cannot contend with an immediate second tap/click in the purchase flow.
    if (reason === 'first-interaction') window.setTimeout(scheduleIdle, 1200);
    else scheduleIdle();
  };

  function requestFromInteraction() {
    requestLoad('first-interaction');
  }

  interactionEvents.forEach((eventName) => {
    window.addEventListener(eventName, requestFromInteraction, {
      capture: true,
      passive: true,
      once: false,
    });
  });

  const startFallback = () => {
    fallbackTimer = window.setTimeout(() => requestLoad('fallback-12s'), 12000);
  };
  if (document.readyState === 'complete') startFallback();
  else window.addEventListener('load', startFallback, { once: true });
})();
